import { FormSubmitAction } from './FormSubmitAction';
FormSubmitAction.displayName = "FormSubmitAction";
export { FormSubmitAction as default };